var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGbSct = function SvgGbSct(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0065bd",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0l5 3M0 3l5-3",
    stroke: "#fff",
    strokeWidth: 0.6,
    transform: "scale(128 160)"
  })));
};
export default __webpack_public_path__ + "assets/1515d5870f91d9f93887cff807e27197.svg";
export { SvgGbSct as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gb-sct.svg